import { Suspense, useEffect } from 'react';
import moment from 'moment-timezone';
import { Navigate, Route, Routes } from 'react-router-dom';

import PrivateRoute from './components/routerHelper/PrivateRoute';
import PublicRoute from './components/routerHelper/PublicRoute';
import WithNavbar from './components/WithNavbar/WithNavbar';

import NotFound from './pages/NotFound/NotFound.lazy';
import Login from './pages/Login/Login.lazy';
import Chat from './pages/Chat/Chat.lazy';
import Home from './pages/Home/Home.lazy';
import Logout from './pages/Logout/Logout.lazy';
import CONSTANT from './utils/constant';
import API from './services/API';

import './App.scss';

function App() {
  // const checkServerTime = async () => {
  //   const res = await API.getServerTime();
  //   if (res.success) {
  //     const serverTime = res.data;
  //     if (moment().diff(moment(serverTime), 'seconds') > 5) {
  //       alert(
  //         `THỜI GIAN TRÊN MÁY CỦA BẠN KHÔNG CHÍNH XÁC VỚI SERVER. YÊU CẦU CẬP NHẬT CHÍNH XÁC ${moment(
  //           serverTime,
  //         ).format(CONSTANT.DATE_FORMAT.LONG)} ĐỂ SỬ DỤNG HỆ THỐNG.`,
  //       );
  //       window.location.href = '/logout';
  //     }
  //   }
  // };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     checkServerTime();
  //   }, 10000);
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <WithNavbar />
            </PrivateRoute>
          }
        >
          <Route path="/" element={<Chat />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/new" element={<Home />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/not-found" element={<NotFound />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

export default App;
